'use es6';

export default ((...classNames) => {
  return classNames.filter(name => typeof name === 'string').join(' ').replace(/ +/g, ' ').trim();
});